import { Link } from 'react-router-dom';

import { useEmbedBootstrap } from '../use-widget-bootstrap';
import { useQuerySuffix } from '../widget-hooks/useQuerySuffix';
import { PATH } from '../widget-lib/path-routes';
import { EmbedFeedbackButton } from './EmbedFeedbackButton';

/** Строка-ссылка документа: высота не меньше 48 dp (mobile touch target). */
const rowClass =
  'flex min-h-12 items-center justify-between border-b border-[var(--border)] px-4 py-3.5 text-sm font-medium text-[var(--text)] transition-all duration-200 last:border-b-0 active:scale-[0.99] hover:bg-[var(--bg-soft)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--focus-ring)]';

/**
 * Юридические документы и обратная связь в профиле мобильного приложения
 * (вместо ссылок внизу каждого экрана).
 */
export function MobileLegalLinks() {
  const suffix = useQuerySuffix();
  const { orgSlug, accessToken } = useEmbedBootstrap();
  const docs = [
    { to: PATH.legalCrm, label: 'Публичная оферта' },
    { to: PATH.legalRules, label: 'Пользовательское соглашение' },
    { to: PATH.legalPrivacy, label: 'Политика конфиденциальности' },
    ...(orgSlug ? [{ to: PATH.legalOrganization, label: 'Соглашение с организацией' }] : [])
  ];

  return (
    <section aria-labelledby="mobile-legal-links-title" className="space-y-2">
      <h2 id="mobile-legal-links-title" className="px-1 text-xs font-semibold uppercase tracking-wider text-[var(--text-muted)]">
        Документы
      </h2>
      <nav className="overflow-hidden rounded-2xl bg-[var(--bg-elevated)] shadow-[var(--shadow-card)]">
        {docs.map((d) => (
          <Link key={d.to} to={`${d.to}${suffix}`} className={rowClass}>
            {d.label}
            <span className="text-[var(--text-muted)] leading-none" aria-hidden>
              ›
            </span>
          </Link>
        ))}
      </nav>
      {accessToken ? (
        <div className="flex justify-center pt-1">
          <EmbedFeedbackButton variant="inline" />
        </div>
      ) : null}
    </section>
  );
}
